// extracted by mini-css-extract-plugin
export default {"footer":"PanelDesktopFooter_footer__H7azt"};